import { push } from 'connected-react-router';
import { getTeamUrl } from 'Common';

export default (valuation) => async (dispatch) => {

  dispatch(push(getTeamUrl(`valuations/${valuation.id}/view`)))

}